export default "__VITE_ASSET__ClJ7UQJM__"